// import React, { useState, useEffect, useCallback } from "react";
// import DataTable from "react-data-table-component";
// import FilterModal from "../Filter Modal/FilterModal";
// import axios from "axios";
// import moment from "moment";

// export default function DataTable_Component({
//   apidata,
//   columns,
//   searchBy,
//   onFilterApply,
// }) {
//   const [dataFilter, setDataFilter] = useState("");
//   const [hubFilter, setHubFilter] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [showFilterModal, setShowFilterModal] = useState(false);
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [payoutTotal, setPayoutTotal] = useState(0);

//   // Function to validate if a date is valid
//   const isValidDate = (date) => {
//     return moment(date, "YYYY-MM-DD", true).isValid();
//   };

//   const fetchData = async (fromDateParam, toDateParam) => {
//     if (!isValidDate(fromDateParam) || !isValidDate(toDateParam)) {
//       console.log("Invalid dates provided.");
//       return;
//     }

//     try {
//       const token = localStorage.getItem("token");
//       if (!token) {
//         console.error("No token found");
//         return;
//       }

//       console.log("Fetching data with dates:");
//       console.log("FROM DATE", fromDateParam);
//       console.log("TO DATE", toDateParam);

//       const url = `${process.env.REACT_APP_BASE_URL}/api/v3/orders-consolidate/hub-summary`;

//       const response = await axios.get(url, {
//         params: {
//           dateFrom: fromDateParam,
//           dateTo: toDateParam,
//         },
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (Array.isArray(response.data.hubSummary)) {
//         const hubSummary = response.data.hubSummary;

//         // Fetch totalPayout for each hub
//         const payoutPromises = hubSummary.map(async (hub) => {
//           const payoutUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/orders-consolidate-payouts/hub-summary`;
//           try {
//             const payoutResponse = await axios.get(payoutUrl, {
//               params: {
//                 dateFrom: fromDateParam,
//                 dateTo: toDateParam,
//                 hubId: hub.hubId,
//               },
//               headers: {
//                 Authorization: `Bearer ${token}`,
//               },
//             });

//             const payout =
//               payoutResponse.data?.hubSummary?.[0]?.totalPayout || 0;

//             // ✅ Adjust payout if 0 but totalAmount exists
//             let adjustedPayout = payout;
//             const totalAmount = hub.totalAmount;

//             if (adjustedPayout === 0 && totalAmount && totalAmount > 0) {
//               adjustedPayout = totalAmount;
//             }

//             return {
//               ...hub,
//               totalPayout: adjustedPayout,
//             };
//           } catch (err) {
//             console.error(`Error fetching payout for hub ${hub.hubId}`, err);
//             // fallback to totalAmount if available
//             return {
//               ...hub,
//               totalPayout: hub.totalAmount || 0,
//             };
//           }
//         });

//         const enrichedData = await Promise.all(payoutPromises);
//         setFilteredData(enrichedData);
//       } else {
//         console.error(
//           "Unexpected data format from API",
//           response.data.hubSummary
//         );
//       }
//     } catch (error) {
//       console.error("Error fetching data: ", error);
//     }
//   };

//   const debounceFetchData = useCallback(
//     debounce(() => {
//       fetchData();
//     }, 500),
//     [fromDate, toDate]
//   );

//   useEffect(() => {
//     if (isValidDate(fromDate) && isValidDate(toDate)) {
//       debounceFetchData();
//     }
//     return debounceFetchData.cancel;
//   }, [fromDate, toDate, debounceFetchData]);

//   useEffect(() => {
//     const total = filteredData.reduce((sum, item) => {
//       return sum + (item.totalPayout || 0);
//     }, 0);
//     setPayoutTotal(total);
//   }, [filteredData]);

//   useEffect(() => {
//     let filtered = apidata;

//     if (hubFilter) {
//       filtered = filtered.filter((item) => {
//         return (
//           item.hubName &&
//           item.hubName.toLowerCase().includes(hubFilter.toLowerCase())
//         );
//       });
//     }

//     if (dataFilter) {
//       filtered = filtered.filter((item) => {
//         if (searchBy === "hubName") {
//           return (
//             item.hubName &&
//             item.hubName.toLowerCase().includes(dataFilter.toLowerCase())
//           );
//         }
//         return false;
//       });
//     }

//     setFilteredData(filtered);
//   }, [dataFilter, hubFilter, apidata, searchBy]);

//   const applyFilters = () => {
//     if (isValidDate(fromDate) && isValidDate(toDate)) {
//       const formattedFromDate = moment(fromDate).format("YYYY-MM-DD");
//       const formattedToDate = moment(toDate).format("YYYY-MM-DD");

//       console.log("Applying filter with dates:");
//       console.log("From Date:", formattedFromDate);
//       console.log("To Date:", formattedToDate);

//       onFilterApply(formattedFromDate, formattedToDate);
//       fetchData(formattedFromDate, formattedToDate);
//       setShowFilterModal(false);
//     } else {
//       console.error("Invalid dates provided for applying filters.");
//     }
//   };

//   const removeFilters = () => {
//     setFromDate("");
//     setToDate("");
//     setHubFilter("");
//     setDataFilter("");
//     setFilteredData(apidata);
//     onFilterApply("", "");
//   };
//   return (
//     <div className="table-responsive">
//       <div className="row justify-content-between mb-2">
//         <div className="col-md-3 mb-2">
//           <input
//             type="text"
//             placeholder={`Search by ${searchBy}`}
//             className="form-control"
//             value={dataFilter}
//             onChange={(e) => setDataFilter(e.target.value)}
//           />
//         </div>
//         <div className="col-md-9 mb-2 d-flex align-items-center">
//           <button
//             className="btn btn-primary me-2"
//             onClick={() => setShowFilterModal(true)}
//           >
//             Filter
//           </button>
//           <button className="btn btn-success me-2">
//             Revenue : {payoutTotal.toLocaleString()} /-
//           </button>
//         </div>
//       </div>

//       {filteredData.length > 0 ? (
//         <DataTable
//           columns={columns}
//           data={filteredData}
//           pagination
//           fixedHeader
//           highlightOnHover
//           responsive
//           paginationPerPage={5}
//           paginationRowsPerPageOptions={[5, 10, 15, 20]}
//         />
//       ) : (
//         <div className="row justify-content-start">
//           <div className="col-12">
//             <p>No results found.</p>
//           </div>
//         </div>
//       )}

//       <FilterModal
//         show={showFilterModal}
//         onHide={() => setShowFilterModal(false)}
//         hubFilter={hubFilter}
//         setHubFilter={setHubFilter}
//         applyFilters={applyFilters}
//         removeFilters={removeFilters}
//         apidata={apidata} // Ensure apidata contains hubName
//         fromDate={fromDate} // Pass fromDate
//         setFromDate={setFromDate} // Allow updating fromDate
//         toDate={toDate} // Pass toDate
//         setToDate={setToDate} // Allow updating toDate
//       />
//     </div>
//   );
// }
// // Utility function for debouncing
// function debounce(func, delay) {
//   let timeout;
//   const debouncedFunc = (...args) => {
//     clearTimeout(timeout);
//     timeout = setTimeout(() => func(...args), delay);
//   };
//   debouncedFunc.cancel = () => clearTimeout(timeout);
//   return debouncedFunc;
// }

import React, { useState, useEffect, useCallback } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";
import axios from "axios";
import moment from "moment";

export default function DataTable_Component({
  apidata,
  columns,
  searchBy,
  onFilterApply,
}) {
  const [dataFilter, setDataFilter] = useState("");
  const [hubFilter, setHubFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [payoutTotal, setPayoutTotal] = useState(0);

  // Utility to get previous month date range
  const getPreviousMonthRange = () => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth(), 0);
    const formatDate = (date) => moment(date).format("YYYY-MM-DD");
    return {
      from: formatDate(firstDay),
      to: formatDate(lastDay),
    };
  };

  // Validate if a date is valid
  const isValidDate = (date) => {
    return moment(date, "YYYY-MM-DD", true).isValid();
  };

  const fetchData = async (fromDateParam, toDateParam) => {
    if (!isValidDate(fromDateParam) || !isValidDate(toDateParam)) {
      console.log("Invalid dates provided.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }
      const url = `${process.env.REACT_APP_BASE_URL}/api/v3/orders-consolidate/hub-summary`;

      const response = await axios.get(url, {
        params: {
          dateFrom: fromDateParam,
          dateTo: toDateParam,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (Array.isArray(response.data.hubSummary)) {
        const hubSummary = response.data.hubSummary;

        const payoutPromises = hubSummary.map(async (hub) => {
          const payoutUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/orders-consolidate-payouts/hub-summary`;
          try {
            const payoutResponse = await axios.get(payoutUrl, {
              params: {
                dateFrom: fromDateParam,
                dateTo: toDateParam,
                hubId: hub.hubId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });

            const payout =
              payoutResponse.data?.hubSummary?.[0]?.totalPayout || 0;

            let adjustedPayout = payout;
            const totalAmount = hub.totalAmount;

            if (adjustedPayout === 0 && totalAmount && totalAmount > 0) {
              adjustedPayout = totalAmount;
            }

            return {
              ...hub,
              totalPayout: adjustedPayout,
            };
          } catch (err) {
            console.error(`Error fetching payout for hub ${hub.hubId}`, err);
            return {
              ...hub,
              totalPayout: hub.totalAmount || 0,
            };
          }
        });

        const enrichedData = await Promise.all(payoutPromises);
        setFilteredData(enrichedData);
      } else {
        console.error(
          "Unexpected data format from API",
          response.data.hubSummary
        );
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  // Debounced fetch
  const debounceFetchData = useCallback(
    debounce(() => {
      fetchData(fromDate, toDate);
    }, 500),
    [fromDate, toDate]
  );

  // Fetch data when dates change
  useEffect(() => {
    if (isValidDate(fromDate) && isValidDate(toDate)) {
      debounceFetchData();
    }
    return debounceFetchData.cancel;
  }, [fromDate, toDate, debounceFetchData]);

  // Calculate total payout
  useEffect(() => {
    const total = filteredData.reduce((sum, item) => {
      return sum + (item.totalPayout || 0);
    }, 0);
    setPayoutTotal(total);
  }, [filteredData]);

  // Filter table data on search/hub change
  useEffect(() => {
    let filtered = apidata;

    if (hubFilter) {
      filtered = filtered.filter((item) => {
        return (
          item.hubName &&
          item.hubName.toLowerCase().includes(hubFilter.toLowerCase())
        );
      });
    }

    if (dataFilter) {
      filtered = filtered.filter((item) => {
        if (searchBy === "hubName") {
          return (
            item.hubName &&
            item.hubName.toLowerCase().includes(dataFilter.toLowerCase())
          );
        }
        return false;
      });
    }

    setFilteredData(filtered);
  }, [dataFilter, hubFilter, apidata, searchBy]);

  // Apply date filters
  const applyFilters = () => {
    if (isValidDate(fromDate) && isValidDate(toDate)) {
      const formattedFromDate = moment(fromDate).format("YYYY-MM-DD");
      const formattedToDate = moment(toDate).format("YYYY-MM-DD");

      onFilterApply(formattedFromDate, formattedToDate);
      fetchData(formattedFromDate, formattedToDate);
      setShowFilterModal(false);
    } else {
      console.error("Invalid dates provided for applying filters.");
    }
  };

  const removeFilters = () => {
    const { from, to } = getPreviousMonthRange();
    setFromDate(from);
    setToDate(to);
    setHubFilter("");
    setDataFilter("");
    fetchData(from, to);
    onFilterApply(from, to);
  };

  // Initial load: set default date range to previous month
  useEffect(() => {
    if (!fromDate && !toDate) {
      const { from, to } = getPreviousMonthRange();
      setFromDate(from);
      setToDate(to);
      fetchData(from, to);
    }
  }, []);

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div>
        <div className="col-md-9 mb-2 d-flex align-items-center">
          <button
            className="btn btn-primary me-2"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
          <button className="btn btn-success me-2">
            Revenue : {payoutTotal.toLocaleString()} /-
          </button>
        </div>
      </div>

      {filteredData.length > 0 ? (
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          fixedHeader
          highlightOnHover
          responsive
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
        />
      ) : (
        <div className="row justify-content-start">
          <div className="col-12">
            <p>No results found.</p>
          </div>
        </div>
      )}

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        hubFilter={hubFilter}
        setHubFilter={setHubFilter}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        apidata={apidata}
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
      />
    </div>
  );
}

// Utility function for debouncing
function debounce(func, delay) {
  let timeout;
  const debouncedFunc = (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
  debouncedFunc.cancel = () => clearTimeout(timeout);
  return debouncedFunc;
}
